<template>
  <div
      class="l-content"
      :class="{'l-content__reverse': _reverse}">
    <div class="l-column mobile">
      <img :src=_imageUrl alt="image">
    </div>
    <div class="l-column" :style="mTextStyle">
      <div class="l-text-content"
           :class="{'text-align-right': _reverse}">
        <div class="text-title"
             :class="{'text-title-light-mode': _lightMode}">
          {{_textTitle}}</div>
        <div class="break-title"></div>
        <div
            class="text-subtitle"
            :class="{'text-light-mode': _lightMode}">
          {{_textSubTitle}}</div>
        <div class="break-subtitle"></div>

        <div v-for="desc in _textDescription"
             :key="desc.id"
             class="text-description"
             :class="{'text-light-mode': _lightMode}">
          <div>{{desc}}</div>
          <div class="break-paragraph"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logger from '../utils/logger'

const LOG_TAG = 'RowInfoSection'

export default {
  name: 'RowInfoSection',
  props: {
    _imageUrl: {
      type: String,
      default: require('../assets/bsLogo.png')
    },
    _textBackground: {
      type: String,
      default: '#3c94a4'
    },
    _lightMode: {
      type: Boolean,
      default: false
    },
    _textTitle: {
      type: String,
      default: ''
    },
    _textSubTitle: {
      type: String,
      default: ''
    },
    _textDescription: Array,
    _reverse: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      mTextStyle: {
      }
    }
  },
  mounted () {
    const vm = this
    vm.mTextStyle = {
      backgroundColor: vm._textBackground
    }
    logger.d(LOG_TAG, 'mounted', vm._lightMode)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .l-debug {
    border-width: 1px;
    border-color: red;
    border-style: dashed;
  }
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .break-title {
    height: 3rem;
  }
  .break-subtitle {
    height: 2rem;
  }
  .break-paragraph {
    height: 1rem;
  }
  .l-content {
    display: flex;
    flex-direction: row;
    min-height: 480px;
  }
  .l-content__reverse {
    flex-direction: row-reverse;
  }
  .l-content .l-column {
    flex-basis: 0;
    flex-grow: 1;
  }
  .l-content .l-column img {
    display: inline-block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .l-content .l-column .l-text-content {
    display: inline-block;
    width: 60%;
    height: 100%;
    text-align: left;
    padding-top: 6rem;
    padding-bottom: 6rem;
  }
  .text-title {
    font-weight: bolder;
    font-size: xx-large;
    color: #fcfcfc;
  }
  .text-subtitle {
    font-weight: normal;
    font-size: large;
    color: #fcfcfc;
  }
  .text-description {
    font-weight: normal;
    color: #fcfcfc;
  }
  .text-title-light-mode {
    color: #3c94a4;
  }
  .text-light-mode {
    color: black;
  }
  .l-content .l-column .l-text-content.text-align-right {
    text-align: right;
  }
  @media screen and (max-width: 768px) {
    .mobile {
      display: none;
    }
    .l-content {
      flex-direction: column;
      min-height: 268px;
    }
    .l-content .l-column .l-text-content {
      width: 86%;
      padding-top: 2rem;
      padding-bottom: 2rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/RowInfoSection.vue